import { render, staticRenderFns } from "./_edit.vue?vue&type=template&id=99cb0510"
import script from "./_edit.vue?vue&type=script&lang=js"
export * from "./_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports